/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerFindOneQueryResponse, ClientsControllerFindOnePathParams, ClientsControllerFindOneQueryParams, ClientsControllerFindOne400, ClientsControllerFindOne401, ClientsControllerFindOne403, ClientsControllerFindOne404 } from "../../models/clientsController/ClientsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { clientsControllerFindOne } from "../../clients/clientsService/clientsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const clientsControllerFindOneQueryKey = (id: ClientsControllerFindOnePathParams["id"], params: ClientsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/clients/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ClientsControllerFindOneQueryKey = ReturnType<typeof clientsControllerFindOneQueryKey>;
export function clientsControllerFindOneQueryOptions(id: ClientsControllerFindOnePathParams["id"], params?: ClientsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = clientsControllerFindOneQueryKey(id, params);
  return queryOptions<ClientsControllerFindOneQueryResponse, ResponseErrorConfig<ClientsControllerFindOne400 | ClientsControllerFindOne401 | ClientsControllerFindOne403 | ClientsControllerFindOne404>, ClientsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return clientsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a client by ID
 * {@link /api/v1/clients/:id}
 */
export function useClientsControllerFindOne<TData = ClientsControllerFindOneQueryResponse, TQueryData = ClientsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ClientsControllerFindOneQueryKey>(id: ClientsControllerFindOnePathParams["id"], params?: ClientsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClientsControllerFindOneQueryResponse, ResponseErrorConfig<ClientsControllerFindOne400 | ClientsControllerFindOne401 | ClientsControllerFindOne403 | ClientsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? clientsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...clientsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClientsControllerFindOne400 | ClientsControllerFindOne401 | ClientsControllerFindOne403 | ClientsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}